import { useState } from "react";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import RecordSummarySelect from "./RecordSummarySelect";
import { SelectPicker } from "rsuite";
import { FormGroup } from "reactstrap";

export default function RecordSummarySettings({
  dataSources,
  summaryFields,
  handleSelectField,
  handleReorderFields,
  fieldType,
  displayModeChange,
}) {
  const [active, setActive] = useState(0);

  const displayOptions = () => {
    const options = [
      { label: "Summary Card", value: "SummaryCard" },
      { label: "Regular Field", value: "RegularField" },
    ];

    if (fieldType === "MultiReference") {
      options.push({ label: "Summary Table", value: "SummaryTable" });
    }

    return [...options];
  };

  return (
    <div>
      <Nav tabs>
        {dataSources.map((source, i) => (
          <NavItem key={`tab-${source}-${i}`} className="cursor-pointer">
            <NavLink
              onClick={() => setActive(i)}
              className={active === i ? "active" : null}
            >
              {source.split("Modules.", 2)[1] || source.split("Lists.", 2)[1]}
            </NavLink>
          </NavItem>
        ))}
      </Nav>
      <TabContent activeTab={active}>
        {dataSources.map((source, i) => {
          let dataSource =
            source.split("Modules.", 2)[1] || source.split("Lists.", 2)[1];

          return (
            <TabPane key={`content-${source}-${i}`} tabId={i}>
              <div className="border-right border-bottom border-left p-2">
                <div className="mb-2">
                  <RecordSummarySelect
                    handleSelectField={(value) => {
                      handleSelectField(value, dataSource);
                    }}
                    handleReorderFields={(newOrder) =>
                      handleReorderFields(newOrder, dataSource)
                    }
                    moduleProp={dataSource}
                    existingFields={summaryFields[dataSource]?.Fields}
                  />
                </div>
                <FormGroup>
                  <h5>Display Mode</h5>
                  <SelectPicker
                    searchable={false}
                    preventOverflow
                    block
                    value={summaryFields[dataSource].summaryPresentation}
                    onChange={(val) => {
                      for (let i = 0; i < dataSources?.length; i++) {
                        const source = dataSources[i];

                        const dataSource =
                          `${source?.split("Modules.", 2)[1]}` ||
                          `${source?.split("Lists.", 2)[1]}`;
                        displayModeChange(val, dataSource);
                      }
                    }}
                    data={displayOptions()}
                  />
                </FormGroup>
              </div>
            </TabPane>
          );
        })}
      </TabContent>
    </div>
  );
}
